import { Injectable } from '@angular/core';
import SnowflakeId from 'snowflake-id';

@Injectable({
    providedIn: 'root',
})
export class SnowflakeIdService {
    private snowflake: SnowflakeId;

    constructor() {
        this.snowflake = new SnowflakeId({
            mid: 42,
            offset: (2024 - 1970) * 31536000 * 1000,
        });
    }

    generateId(): string {
        return this.snowflake.generate().toString();
    }
}
